import React from 'react'

import Title from '../shared/title'
import SubmitButton from '../shared/submit-button'
import { AuthModalBody } from '../auth-modal/auth-modal-body'
import Iconify from '@/components/Iconify/Iconify'
import Logo from '../shared/logo'
import history from '@/routes/history'

import useAuth from '../../hooks/use-auth'

export default function WelcomeSuccess () {
  const { closeModal } = useAuth()

  return (
    <AuthModalBody>
      <Logo
        src='/images/Pickwin.png'
        alt='Pickwin logo'
      />
      <Iconify
        icon='ep:success-filled'
        style={{ fontSize: '3.5em', color: '#78bc28', margin: '0 auto' }}
      />
      <Title>¡Felicidades, tú cuenta se verificó con éxito!</Title>
      <SubmitButton
        onClick={() => {
          closeModal()
          history.push('/')
        }}
      >
        Regresar al Lobby Principal
      </SubmitButton>
    </AuthModalBody>
  )
}
